import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

function applyTheme(theme) {
  if (!theme) return;
  const root = document.documentElement;
  const map = {
    primary: "--c-primary", secondary: "--c-secondary", accent: "--c-accent",
    bgMain: "--c-bg", bgAlt: "--c-bg-alt", card: "--c-card", text: "--c-text",
    textMuted: "--c-muted", border: "--c-border",
  };
  Object.entries(map).forEach(([k, v]) => {
    if (theme[k]) root.style.setProperty(v, theme[k]);
  });
  if (theme.radius) root.style.setProperty("--c-radius", `${theme.radius}px`);
  if (theme.headingFont) root.style.setProperty("--font-heading", `'${theme.headingFont}'`);
  if (theme.bodyFont) root.style.setProperty("--font-body", `'${theme.bodyFont}'`);
}

export function SiteProvider({ children }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const res = await api.get("/public/site");
      setData(res.data);
      applyTheme(res.data?.site?.theme);
      const seo = res.data?.site?.seo;
      if (seo?.title) document.title = seo.title;
    } catch (e) {
      /* keep null */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <SiteContext.Provider value={{ ...(data || {}), loading, reload: load, applyTheme }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
export { applyTheme };
